import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/en";
import { Grid } from "@mui/material";
import { isValidNumber } from "libphonenumber-js";
import { StartIcon, DiamondIcon, ChrownIcon, SphereIcon } from "@/icons";
import {
  roles,
  MANAGE_DOMAIN_OPERATIONS,
  MANAGE_ORG_OPERATIONS,
  EXECUTIVE_OPERATIONS,
  SUPER_ADMIN_OPERATIONS,
  API_PUBLISHER_OPERATIONS,
  API_DEVELOPER_OPERATIONS,
  WEBAPP_USER_OPERATIONS,
  SYSTEM_ORG_OPERATIONS
} from "@/libs/roleWiseScreen";
import {
  PARTNER_CALLBACK_URL,
  MASTER_CALLBACK_URL,
  SYS_ADMIN_CALLBACK_URL,
  DEVICE_MANAGER_CALLBACK_URL,
  MASTER_SUB_DOMAIN,
  PARTNER_SUB_DOMAIN,
  EVES_SUB_SYS_DOMAIN,
  DEVICE_SUB_DOMAIN
} from "@/config";

import { getCookie } from "..";
import { getSubdomain } from "@/utils/common";
import DeviceManager from "../../images/Device_Manager.png";
import Integrations from "../../images/App_Registry.png";
import Partner from "../../images/Access_Manager.png";
import SystemAdmin from "../../images/EVES_Ops.png";

interface CsvData {
  [key: string]: string;
}

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("en");

const loggedUserDetails = getCookie("xsm_user_details")
  ? JSON.parse(getCookie("xsm_user_details") || "")
  : "";
const org = getCookie("xsm_user_organization")
  ? JSON.parse(getCookie("xsm_user_organization") || "")
  : "";

export const DateAndTimeFormat = ({ date, format }: any) => {
  return dayjs(date).tz("America/Los_Angeles").format(format);
};

export const AccordianData = ({ header = "Action history", row }: any) => {
  return [
    {
      accordianHeader: header,
      accordianBody: [
        {
          heading: `Modified on ${DateAndTimeFormat({
            date: row?.modified_on,
            format: "MM/DD/YYYY"
          })} at ${DateAndTimeFormat({
            date: row?.modified_on,
            format: "HH:mm A"
          })}`,
          subHeading: `by ${row?.modified_by}`
        },
        {
          heading: `Created on ${DateAndTimeFormat({
            date: row?.created_on,
            format: "MM/DD/YYYY"
          })} at ${DateAndTimeFormat({
            date: row?.created_on,
            format: "HH:mm A"
          })}`,
          subHeading: `by ${row?.created_by}`
        }
      ]
    }
  ];
};

export const isInclude = (data: any, object: any) => {
  let ind = -1;
  const include =
    data?.filter((item: any, index: any) => {
      if (JSON.stringify(item) == JSON.stringify(object)) {
        ind = index;
        return true;
      }
    }).length > 0;

  return { include, ind };
};

export const getStatus = (status: any) => {
  const theme = localStorage.getItem("theme");
  switch (status) {
    case "CREATED":
      return { bg: "#334155", color: "#FFF" };
    case "PUBLISHED":
      return { bg: "rgba(209, 250, 229, 0.50)", color: theme === "dark" ? "#14b2b2" : "#059691" };
    case "UNPUBLISHED":
      return { bg: "rgba(255, 228, 230, 0.50)", color: "#E11D48" };
  }
};

export const capitalize = (str: any) => {
  const status = str?.toLowerCase();
  return status?.charAt(0)?.toUpperCase() + status?.slice(1);
};

export const validatePhoneNumberGoogle = (countryCode: any, phoneNumber: any) => {
  try {
    const parsedNumber = isValidNumber(`${countryCode}${phoneNumber}`);
    return parsedNumber;
  } catch (error) {
    return false;
  }
};

export const getData = (chip: any) => {
  if (chip == "U") {
    return (
      <Grid display={"flex"} alignItems={"center"} gap={"4px"}>
        <StartIcon /> Unlimited
      </Grid>
    );
  } else if (chip == "G") {
    return (
      <Grid display={"flex"} alignItems={"center"} gap={"4px"}>
        <ChrownIcon /> Gold
      </Grid>
    );
  } else if (chip == "S") {
    return (
      <Grid display={"flex"} alignItems={"center"} gap={"4px"}>
        <DiamondIcon /> Silver
      </Grid>
    );
  } else {
    return (
      <Grid display={"flex"} alignItems={"center"} gap={"4px"}>
        <SphereIcon /> Bronze
      </Grid>
    );
  }
};

export const getStatusBadge = (status: boolean) => {
  return status === true ? "#D1FAE5" : "#FFE4E6";
};
// const combineRoles = (Roles: any) => {
//   const finalRoles: any = {};
//   Roles.forEach((obj: any) => {
//     for (const key in obj) {
//       if (obj.hasOwnProperty(key)) {
//         if (!finalRoles.hasOwnProperty(key)) {
//           finalRoles[key] = obj[key];
//         } else {
//           finalRoles[key] = finalRoles[key] || obj[key];
//         }
//       }
//     }
//   });
//   return finalRoles;
// };

const combineRoles = (Roles: any) => {
  const finalRoles: any = {};

  Roles.forEach((obj: any) => {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (!Object.prototype.hasOwnProperty.call(finalRoles, key)) {
          finalRoles[key] = obj[key];
        } else {
          finalRoles[key] = finalRoles[key] || obj[key];
        }
      }
    }
  });

  return finalRoles;
};

const getUserRoles = (userRoles: any) => {
  const role: any = [];
  if (Object.keys(userRoles).length === 0) {
    (loggedUserDetails as any)?.organizations?.filter((orgn: any) => {
      if (org.name == orgn.name || orgn.name === "SYSTEM_ORG") {
        orgn?.application?.map((app: any) => {
          app?.role?.map((userrole: any) => {
            if (userrole.type == "S") {
              role.push({ ...userrole, app_uuid: app.id, app_name: app.name });
            }
          });
        });
      }
    });
  } else {
    userRoles.map((item: any) => {
      item?.application?.map((app: any) => {
        app?.role?.map((userrole: any) => {
          if (userrole.type == "S") {
            role.push({ ...userrole, app_uuid: app.id, app_name: app.name });
          }
        });
      });
    });
  }
  return role;
};

export const getSidebarManagement = (userRoles: any) => {
  const role = getUserRoles(userRoles);
  const Roles: any = [];
  if (role.length > 0) {
    role?.map((item: any) => {
      switch (item.name) {
        case "dom_admin":
          Roles.push(roles["DOM_ADMIN"]);
          break;
        case "org_admin":
          Roles.push(roles["ORG_ADMIN"]);
          break;
        case "super_admin":
          Roles.push(roles["SUPER_ADMIN"]);
          break;
        case "api_publisher":
          Roles.push(roles["API_PUBLISHER"]);
          break;
        case "api_developer":
          Roles.push(roles["API_DEVELOPER"]);
          break;
        case "web_app_user":
          Roles.push(roles["WEBAPP_ROLE"]);
          break;
        case "executive":
          Roles.push(roles["EXECUTIVE_ROLE"]);
          break;
        case "SYSTEM_ROLE":
          Roles.push(roles["SYSTEM_ROLE"]);
          break;
      }
    });
  } else {
    Roles.push(roles["EXECUTIVE_ROLE"]);
  }
  const finalRoles = combineRoles(Roles);
  return finalRoles;
};

export const getAccessByRoles = (page = "DOMAIN_MANAGEMENT", userRoles = {}) => {
  const role = getUserRoles(userRoles);
  console.log("role", role);
  const Roles: any = [];
  if (role.length > 0) {
    role?.map((item: any) => {
      switch (item.name) {
        case "XSM-DomainAdmin":
          Roles.push(MANAGE_DOMAIN_OPERATIONS[page]);
          break;
        case "XSM-OrgAdmin":
          Roles.push(MANAGE_ORG_OPERATIONS[page]);
          break;
        case "XSM-SuperUser":
          Roles.push(SUPER_ADMIN_OPERATIONS[page]);
          break;
        case "XSM-Publisher":
          Roles.push(API_PUBLISHER_OPERATIONS[page]);
          break;
        case "XSM-Subscriber":
          Roles.push(API_PUBLISHER_OPERATIONS[page]);
          break;
        case "api_developer":
          Roles.push(API_DEVELOPER_OPERATIONS[page]);
          break;
        case "web_app_user":
          Roles.push(WEBAPP_USER_OPERATIONS[page]);
          break;
        case "executive":
          Roles.push(EXECUTIVE_OPERATIONS[page]);
          break;
        case "SYSTEM_ROLE":
          Roles.push(SYSTEM_ORG_OPERATIONS[page]);
          break;
      }
    });
  } else {
    return Roles.push(EXECUTIVE_OPERATIONS[page]);
  }
  const finalRoles = combineRoles(Roles);
  return finalRoles;
};

export const convertToBase64 = (file: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (typeof reader.result === "string") {
        const base64String = reader.result.split(",")[1];
        resolve(base64String);
      } else {
        reject(new Error("Failed to read file."));
      }
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};

export const getDataFromCsvFile = (selectedFile: any): Promise<CsvData[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e: ProgressEvent<FileReader>) => {
      const contents = e.target?.result?.toString() || "";
      const lines = contents.split("\n");
      const headers = lines[0].split(",");
      const data: CsvData[] = [];

      for (let i = 1; i < lines.length; i++) {
        const obj: CsvData = {};
        const currentLine = lines[i].split(",");

        if (currentLine.length === headers.length) {
          for (let j = 0; j < headers.length; j++) {
            obj[headers[j]] = currentLine[j];
          }
          data.push(obj);
        }
      }

      resolve(data);
    };

    reader.onerror = (e: ProgressEvent<FileReader>) => {
      reject(new Error("Error reading the file"));
    };

    reader.readAsText(selectedFile as Blob);
  });
};

export const CallBackUrlValidation =
  /^(https?:\/\/(?:www\.)?(?:(?:\d+\.\d+.\d+.\d+):\d{1,4}|(?:(?!attacker\.com)[a-zA-Z0-9.-]+)))\/.*$/;

export enum API_TYPES {
  SFS_API = "S",
  IOA_API = "I",
  PT_API = "P",
  GRA_API = "G"
}

export enum APP_TYPES {
  ASSET_APP = "A",
  SUBSCRIBE_APP = "S",
  CONSUMER_APP = "C",
  WEB_APP = "W"
}

export const getCountOfApiCalls = (chip: any) => {
  switch (chip) {
    case "U":
      return "9999999999 Request/Minute";
    case "G":
      return "1000 Request/Minute";
    case "S":
      return "500 Request/Minute";
    case "B":
      return "100 Request/Minute";
    default:
      return "0 Request/Minute";
  }
};

export const todayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};

export const addOneDay = (date: string) => {
  const currentDate = new Date(date);
  currentDate.setDate(currentDate.getDate() + 1);
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const updatedDateString = `${year}-${month}-${day}`;
  return updatedDateString;
};

// Subdomain → organization name (keys from env: REACT_APP_XSM_*_SUB_DOMAIN)
const SUBDOMAIN_ORG_EXCLUSION_MAP: Record<string, string> = {
  [MASTER_SUB_DOMAIN]: "XSM-Master",
  [PARTNER_SUB_DOMAIN]: "Partner",
  [EVES_SUB_SYS_DOMAIN]: "EvesSysAdmin",
  [DEVICE_SUB_DOMAIN]: "DeviceManager"
};

/**
 * Checks if user has the required organization for the given subdomain
 * @param subdomain - The subdomain the user is accessing
 * @param organizations - Array of user's organizations
 * @returns boolean - true if user has required organization, false otherwise
 */
export const hasRequiredOrganization = (subdomain: string, organizations: any[]): boolean => {
  if (!subdomain || !organizations || organizations.length === 0) {
    return false;
  }

  const normalizedSubdomain = subdomain.toLowerCase();
  const requiredOrganizationName = SUBDOMAIN_ORG_EXCLUSION_MAP[normalizedSubdomain];

  if (!requiredOrganizationName) {
    // If subdomain is not in the map, allow access (for other subdomains)
    return true;
  }

  // Check if user has the required organization (excluding SYSTEM_ORG)
  return organizations.some(
    (org) => org?.name === requiredOrganizationName && org?.name !== "SYSTEM_ORG"
  );
};


const ORGANISATION_PRODUCT_CONFIG: Record<
  string,
  { displayName: string; icon: string; link: () => string }
> = {
  "XSM-Master": {
    displayName: "App Registry",
    icon: Integrations,
    link: () => MASTER_CALLBACK_URL
  },
  Partner: {
    displayName: "Access Manager",
    icon: Partner,
    link: () => PARTNER_CALLBACK_URL
  },
  EvesSysAdmin: {
    displayName: "EVES Ops",
    icon: SystemAdmin,
    link: () => SYS_ADMIN_CALLBACK_URL
  },
  DeviceManager: {
    displayName: "Device Manager",
    icon: DeviceManager,
    link: () => DEVICE_MANAGER_CALLBACK_URL
  }
};

export const productListMapping = (organisations: any) => {
  if (!(organisations instanceof Array)) {
    return [];
  }

  const subdomain = getSubdomain()?.toLowerCase() || "";
  const excludedOrganisation = SUBDOMAIN_ORG_EXCLUSION_MAP[subdomain];

  return organisations
    .filter((organisation) => organisation?.name && organisation?.name !== "SYSTEM_ORG")
    .filter((organisation) => organisation?.name !== excludedOrganisation)
    .map((organisation, index) => {
      const config = ORGANISATION_PRODUCT_CONFIG[organisation.name];

      if (!config) {
        return null;
      }

      return {
        id: organisation?.id ?? index,
        name: config.displayName,
        icon: config.icon,
        link: config.link()
      };
    })
    .filter(Boolean);
};

/**
 * Takes a subdomain and returns the product icon and display name for that app.
 * @param subdomain - e.g. "xsm" | "evespartner"
 * @returns { icon, displayName } or null if subdomain has no product config
 */
export const getProductConfigForSubdomain = (
  subdomain: string
): { displayName: string; icon: string } | null => {
  if (!subdomain) return null;
  const orgKey = SUBDOMAIN_ORG_EXCLUSION_MAP[subdomain.toLowerCase()];
  if (!orgKey) return null;
  const config = ORGANISATION_PRODUCT_CONFIG[orgKey];
  if (!config) return null;
  return { displayName: config.displayName, icon: config.icon };
};
